import React from "react";
import type { LucideIcon } from "lucide-react";
import { LoadingSpinner } from "../common/LoadingSpinner";
import { cn } from "../../utils/helpers";

interface StatsCardProps {
  title: string;
  value: string | number;
  icon: LucideIcon;
  color: "blue" | "green" | "red" | "yellow" | "purple" | "indigo";
  change?: string;
  loading?: boolean;
}

export const StatsCard: React.FC<StatsCardProps> = ({
  title,
  value,
  icon: Icon,
  color,
  change,
  loading = false,
}) => {
  const colorClasses = {
    blue: "bg-blue-500 text-blue-100",
    green: "bg-green-500 text-green-100",
    red: "bg-red-500 text-red-100",
    yellow: "bg-yellow-500 text-yellow-100",
    purple: "bg-purple-500 text-purple-100",
    indigo: "bg-indigo-500 text-indigo-100",
  };

  return (
    <div className="bg-white rounded-lg shadow px-6 py-2">
      <div className="flex items-center">
        <div className="flex-shrink-0">
          <div
            className={cn(
              "w-8 h-8 rounded-md flex items-center justify-center",
              colorClasses[color]
            )}
          >
            <Icon className="w-5 h-5" />
          </div>
        </div>
        <div className="ml-4 flex-1">
          <p className="text-sm font-medium text-gray-600">{title}</p>
          <div className="flex items-baseline">
            {loading ? (
              <LoadingSpinner size="sm" />
            ) : (
              <>
                <p className="text-2xl font-semibold text-gray-900">{value}</p>
                {change && (
                  <p className="ml-2 text-sm font-medium text-green-600">
                    {change}
                  </p>
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
